// extracted by mini-css-extract-plugin
export default {"checkbox":"WZlpLG","checkboxError":"N7Xuug"};